import {
  CORE_GET_IOT_ROOMREGIS_INFO_REQUEST,
  CORE_GET_IOT_ROOMREGIS_INFO_SUCCESS,

  CORE_LOAD_IOT_ROOMREGIS_REQUEST,
  CORE_LOAD_IOT_ROOMREGIS_SUCCESS,

  CORE_SEARCH_IOT_REQUEST,
  CORE_SEARCH_IOT_SUCCESS,

  CORE_CREATE_IOT_ROOMREGIS_REQUEST,
  CORE_CREATE_IOT_ROOMREGIS_SUCCESS,

  CORE_UPDATE_IOT_REQUEST,
  CORE_UPDATE_IOT_SUCCESS,

} from '../../types'

const initialState = []
export default {

  iotRoomRegis: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_IOT_ROOMREGIS_REQUEST:
      case CORE_SEARCH_IOT_REQUEST:
        return []
      case CORE_LOAD_IOT_ROOMREGIS_SUCCESS:
      case CORE_SEARCH_IOT_SUCCESS:
        return action.payload

      default:
        return state
    }
  }
  ,
  iotRoomRegisInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_GET_IOT_ROOMREGIS_INFO_REQUEST:
        return {}

      case CORE_GET_IOT_ROOMREGIS_INFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  createIotRoomRegisResult: (state = false, action) => {
    switch (action.type) {
      case CORE_CREATE_IOT_ROOMREGIS_REQUEST:
        return false

      case CORE_CREATE_IOT_ROOMREGIS_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  updateIotRoomRegisResult: (state = false, action) => {
    switch (action.type) {
      case CORE_UPDATE_IOT_REQUEST:
        return false

      case CORE_UPDATE_IOT_SUCCESS:
        return action.payload

      default:
        return state
    }
  },

}


// WEBPACK FOOTER //
// ./src/features/iotRoomRegis/reducer.js